"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var InputText_1 = __importDefault(require("../../../InputText"));
var ada_1 = require("../../../icons/ada");
var bch_1 = require("../../../icons/bch");
var bnb_1 = require("../../../icons/bnb");
var bsc_1 = require("../../../icons/bsc");
var btc_1 = require("../../../icons/btc");
var dai_1 = require("../../../icons/dai");
var doge_1 = require("../../../icons/doge");
var erc_1 = require("../../../icons/erc");
var eth_1 = require("../../../icons/eth");
var ltc_1 = require("../../../icons/ltc");
var trc_1 = require("../../../icons/trc");
var trx_1 = require("../../../icons/trx");
var usdt_1 = require("../../../icons/usdt");
var xrp_1 = require("../../../icons/xrp");
var InputSelect_1 = require("../InputSelect");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var CURRENCIES = [
    { label: 'BTC', value: 'BTC', text: 'Bitcoin', icon: btc_1.BtcIcon },
    { label: 'ETH', value: 'ETH', text: 'Ethereum', icon: eth_1.EthIcon },
    { label: 'USDT', value: 'USDT', text: 'USDT', icon: usdt_1.UsdtIcon },
    { label: 'BCH', value: 'BitcoinCash', text: 'BitcoinCash', icon: bch_1.BchIcon },
    { label: 'LTC', value: 'Litecoin', text: 'Litecoin', icon: ltc_1.LtcIcon },
    { label: 'XRP', value: 'Ripple', text: 'Ripple', icon: xrp_1.XrpIcon },
    { label: 'DOGE', value: 'DOGE', icon: doge_1.DogeIcon },
    { label: 'ADA', value: 'Cardano', text: 'Cardano', icon: ada_1.AdaIcon },
    { label: 'TRX', value: 'TRON', text: 'TRON', icon: trx_1.TrxIcon },
    { label: 'BNB', value: 'BNB', text: 'Binance Coin', icon: bnb_1.BnbIcon },
    { label: 'DAI', value: 'DAI', icon: dai_1.DaiIcon },
];
var NETWORKS = [
    {
        label: 'BSC-20',
        value: 'BSC-20',
        text: 'Binance Smart Chain',
        icon: bsc_1.BscIcon,
    },
    { label: 'ERC-20', value: 'ERC-20', text: 'Ethereum', icon: erc_1.ErcIcon },
    { label: 'TRC-20', value: 'TRC-20', text: 'Tron', icon: trc_1.TrcIcon },
];
var Crypto = function (_a) {
    var method = _a.method, currency = _a.currency, setCurrency = _a.setCurrency, network = _a.network, setNetwork = _a.setNetwork;
    var fields = method.fields.filter(function (f) { return f.name !== 'withdrawal.amount'; });
    var getField = function (field) { return fields.find(function (f) { return f.name === field; }); };
    var cryptoAddress = getField('customer.crypto_address');
    var handleChangeCurrency = function (value) {
        setCurrency(value);
    };
    var handleChangeNetwork = function (value) {
        setNetwork(value);
        // setCurrency(null)
    };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.selects },
            react_1.default.createElement(InputSelect_1.InputSelect, { placeholder: "Cryptocurrency", onChange: handleChangeCurrency, value: currency, options: CURRENCIES }),
            react_1.default.createElement(InputSelect_1.InputSelect, { placeholder: "Network", onChange: handleChangeNetwork, value: network, options: NETWORKS })),
        cryptoAddress && (react_1.default.createElement(CryptoAddressField, { field: cryptoAddress, disabled: !currency || !network }))));
};
var CryptoAddressField = function (_a) {
    var field = _a.field, disabled = _a.disabled;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement(react_final_form_1.Field, { name: field.type, key: "field_name_".concat(field.type) }, function (_a) {
        var input = _a.input, meta = _a.meta;
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.inputWrapper },
            react_1.default.createElement(InputText_1.default, __assign({ labelText: t("".concat(field.name, ".title")), id: field.type, placeholder: t("".concat(field.name, ".placeholder")), type: field.type, isDisabled: disabled, withPaste: true, withClear: true, helpertext: meta.error && meta.touched
                    ? { status: 'error', text: meta.error }
                    : undefined }, input))));
    }));
};
exports.default = Crypto;
